export default __webpack_public_path__ + "static/media/dsi-logo-small.ae769a0f.svg";